
(function(){
  // ---- delivery timeline: end state is the default, animate only when it scrolls in ----
  function initTimeline(){
    document.querySelectorAll('[data-sx-tl]').forEach(function(el){
      if(el.dataset.sxInit) return; el.dataset.sxInit='1';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduce) return;                       // reduced motion: stays filled, package hidden by CSS
      var fill = el.querySelector('.sx-tl-fill');
      var pkg  = el.querySelector('.sx-tl-pkg');
      if(!fill) return;
      // The rail is filled by default (CSS). It is only emptied at the moment it
      // scrolls into view, and refilled on the next frame, so a measurement taken
      // without scrolling never sees an empty rail.
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          io.disconnect();
          var t = fill.style.transition, tp = pkg ? pkg.style.transition : '';
          fill.style.transition='none'; if(pkg) pkg.style.transition='none';
          fill.style.width='0%'; if(pkg) pkg.style.left='0%';
          void fill.offsetWidth;
          requestAnimationFrame(function(){
            fill.style.transition=t||''; if(pkg) pkg.style.transition=tp||'';
            fill.style.width='100%'; if(pkg) pkg.style.left='100%';
          });
        });
      },{threshold:0.35});
      io.observe(el);
    });
  }
  // ---- mobile sticky add to cart ----
  function initSticky(){
    if(!document.body || document.body.dataset.template !== 'product'){
      var main=document.getElementById('MainContent');
      if(!main || main.getAttribute('data-template')!=='product') return;
    }
    if(document.querySelector('.sx-sticky')) return;
    var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
    if(!form) return;
    var realBtn = form.querySelector('button[type="submit"], .add-to-cart-button, [name="add"]');
    if(!realBtn) return;
    var titleEl = document.querySelector('.product-details h1, .product-information h1');
    var priceEl = document.querySelector('.product-details .price, .product-information .price');
    var bar = document.createElement('div');
    bar.className='sx-sticky';
    bar.innerHTML = '<div class="sx-sticky-info"><div class="sx-sticky-title"></div><div class="sx-sticky-price"></div></div><button type="button"></button>';
    bar.querySelector('.sx-sticky-title').textContent = titleEl ? titleEl.textContent.trim() : '';
    function sync(){
      var p = document.querySelector('.product-details .price, .product-information .price');
      bar.querySelector('.sx-sticky-price').textContent = p ? p.textContent.replace(/\s+/g,' ').trim() : '';
      var b = bar.querySelector('button');
      b.textContent = (realBtn.textContent||'Add to cart').replace(/\s+/g,' ').trim();
      b.disabled = !!realBtn.disabled;
    }
    sync();
    bar.querySelector('button').addEventListener('click',function(){ realBtn.click(); });
    document.body.appendChild(bar);
    new MutationObserver(sync).observe(form,{subtree:true,childList:true,attributes:true});
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.bottom < 0); });
    },{threshold:0});
    io.observe(realBtn);
  }
  function boot(){ initTimeline(); initSticky(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();
